import { createContext, useContext, useState, useCallback } from "react";
import QuoteDialog from "@/components/site/QuoteDialog";

const QuoteContext = createContext(null);

export function QuoteProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [lob, setLob] = useState("");
  const [type, setType] = useState("quote");

  const openQuote = useCallback((line = "", formType = "quote") => {
    setLob(line);
    setType(formType);
    setOpen(true);
  }, []);

  return (
    <QuoteContext.Provider value={{ openQuote }}>
      {children}
      <QuoteDialog open={open} onOpenChange={setOpen} defaultLob={lob} type={type} />
    </QuoteContext.Provider>
  );
}

export const useQuote = () => useContext(QuoteContext);
